import { Expose } from "class-transformer";
import { BaseModel } from "./base.model";

export enum BeneficiaryType {
    Headline = "P",
    Contingent = "C",
}

export class Beneficiary extends BaseModel {
    @Expose() id = "";

    @Expose() policyId = -1;

    @Expose() fullName = "";

    @Expose() rate = 0.0;

    @Expose() relationship: Nullable<string> = null;

    @Expose() beneficiaryType: BeneficiaryType = BeneficiaryType.Headline;
}
